import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { RoleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },

  {
    path: 'login',
    loadChildren: () =>
      import('./pages/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },

  {
    path: '',
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['admin', 'alumno'] },
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./pages/home/home.routes').then((m) => m.HOME_ROUTES),
      },
      {
        path: 'planes',
        loadChildren: () =>
          import('./pages/planes/planes.routes').then((m) => m.PLANES_ROUTES),
      },
      {
        path: 'controles',
        loadChildren: () =>
          import('./pages/controles/controles.routes').then(
            (m) => m.CONTROLES_ROUTES,
          ),
      },
      {
        path: 'registros-diarios',
        loadChildren: () =>
          import('./pages/registros-diarios/registros-diarios.routes').then(
            (m) => m.registrosDiariosRoutes,
          ),
      },
    ],
  },

  { path: '**', redirectTo: 'home' },
];
